module.exports = __webpack_public_path__ + "static/media/female-red.7ca8a8ac.png";